import React from 'react';
import { Spinner } from '@crc-evans/ui-components';

export const CustomLoadingCellRenderer = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <Spinner variant="inline" size="medium" />
    </div>
  );
};
